import React from "react";
import { Link, useLocation } from "react-router-dom";
import { activePage, destinationFor } from "@/config/travelerNav";
import { useI18nStore } from "../../stores/i18nStore";

/**
 * The pages of the current destination, as a row of tabs above the page.
 *
 * Medications, immunizations, documents, appointments, the wallet and the
 * subscription were reachable from the sidebar or the avatar menu only; with
 * five destinations instead of nine, this row is where they are found. It
 * renders nothing for a destination with a single page.
 */
const SectionTabs: React.FC = () => {
  const { t } = useI18nStore();
  const { pathname } = useLocation();
  const destination = destinationFor(pathname);

  if (!destination || destination.pages.length < 2) {
    return null;
  }
  const current = activePage(destination, pathname);

  return (
    <nav aria-label={t.navSectionPages} className="-mx-4 mb-6 sm:mx-0">
      <ul className="flex gap-2 overflow-x-auto px-4 pb-1 sm:px-0">
        {destination.pages.map((page) => {
          const active = current?.path === page.path;
          return (
            <li key={page.path} className="shrink-0">
              <Link
                to={page.path}
                aria-current={active ? "page" : undefined}
                className={`inline-flex min-h-[44px] items-center whitespace-nowrap rounded-full px-4 text-sm ${
                  active
                    ? "bg-ink font-bold text-white"
                    : "border border-border bg-white font-semibold text-ink hover:bg-muted"
                }`}
              >
                {page.label(t)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SectionTabs;
